import DatePicker from 'ant-design-vue/es/date-picker/moment';
import TimePicker from 'ant-design-vue/es/time-picker/moment';
import Calendar from 'ant-design-vue/es/calendar/moment';
import { createApp } from 'vue';
import Antd, { message } from 'ant-design-vue';
import { httpClient } from '@/httpClient';
import VueViewer from 'v-viewer';
import InfiniteScroll from 'vue-infinite-scroll';
import * as Sentry from '@sentry/vue';
import { captureConsoleIntegration } from '@sentry/integrations';
import LoadScript from 'vue-plugin-load-script';
import Config from '@/config'; // eslint-disable-line import/extensions
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'ant-design-vue/dist/reset.css';
import 'viewerjs/dist/viewer.css';

const app = createApp(App).use(Antd).use(VueViewer).use(InfiniteScroll);

app.config.productionTip = false;

const renderApp = () => app.use(store).use(router).use(LoadScript).mount('#app');

const token = localStorage.getItem('auth-token');

if (token) {
  store.commit('auth/login');
  httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  store.dispatch('auth/getCurrentUser')
    .catch(() => {
      message.error('Недействительный токен');
      store.commit('auth/logout');
      router.push('/auth');
    })
    .finally(renderApp);
} else {
  renderApp();
}

// A dev server started with a deployed config.js (deploy/config.js.dev* carry an
// empty dsn, the stage/prod ones do not) reports Vue dev-build warnings from
// http://localhost:8080 into the shared project — see BACKOFFICE-28Y/28Z.
const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

if (!isLocalhost) {
  Sentry.init({
    app,
    dsn: Config.sentry.dsn,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      captureConsoleIntegration(['error']),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.005,
    environment: Config.sentry.environment,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      // Announcement banners logged via console.error — not real errors, drop at the boundary.
      'Interface initialized successfully',
      /\[StylePanel v[\d.]+\]/,
      /\[Конструктор\]/,
    ],
    // Browser-extension code injected into the page is not ours — errors from it
    // (e.g. eppiocemhmnlbhjplcgkofciiegomcon: BACKOFFICE-1YH/1WN/25Y/1Y6) are noise.
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-(web-)?extension:\/\//i,
    ],
  });
}
